/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import Header from "../../Layouts/Header";
import Footer from "../../Layouts/Footer";
import Grid from "@material-ui/core/Grid";
import Breadcrumb from "../../Layouts/Breadcrumb";
import Typography from "@material-ui/core/Typography";
import { TextField } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import AuthApi from "../../Services/Authapi";
import swal from "sweetalert";
import moment from "moment";
import AuthCheckComponent from "../../Layouts/Token";
import { createSwalLoaderNode } from "../../Layouts/swalLoader";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import "./Leave.css";

const inileaves = {
  leaveName: "",
  date: "",
};

const AddLeaves = (props) => {
  const classes = props;
  const [leaveValues, setLeaveValues] = useState(inileaves);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const getFinancialYearForDate = (date) => {
    const parsedDate = moment(date, ["YYYY-MM-DD", "DD-MM-YYYY", "MM-DD-YYYY"], true);
    if (!parsedDate.isValid()) {
      return null;
    }

    const startYear = parsedDate.month() >= 3 ? parsedDate.year() : parsedDate.year() - 1;
    return `${startYear}-${startYear + 1}`;
  };

  useEffect(() => {
    if (props && props.authToken === false) {
      // props.history.push("/login");
    }
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setLeaveValues({ ...leaveValues, [name]: value });
  };

  const handleDateChange = (newDate) => {
    if (newDate && !isNaN(new Date(newDate))) {
      const formatted = moment(newDate).format("YYYY-MM-DD");
      setLeaveValues((prev) => ({ ...prev, date: formatted }));
    } else {
      setLeaveValues((prev) => ({ ...prev, date: "" }));
    }
  };

  const validate = (values) => {
    let errors = {};
    const regex = /^[a-zA-Z]/;
    const dateR = /^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$/;

    if (!values.leaveName) {
      errors.leaveName = "Cannot be blank";
    } else if (!regex.test(values.leaveName)) {
      errors.leaveName = "Invalid leave name format";
    }

    if (!values.date) {
      errors.date = "Cannot be blank";
    } else if (!dateR.test(values.date)) {
      errors.date = "Invalid date format";
      // } else {
      //   const selectedDate = moment(values.date, "YYYY-MM-DD");
      //   const dayOfWeek = selectedDate.day();
      //   if (dayOfWeek === 6 || dayOfWeek === 0) {
      //     errors.date = "Weekends are not allowed";
      //   }
      // }
    }

    return errors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errors = validate(leaveValues);
    setFormErrors(errors);

    if (Object.keys(errors).length === 0) {
      setIsSubmitting(true);
    } else if (errors.date) {
      swal({
        title: "Invalid Date",
        text: errors.date,
        icon: "error",
      });
    }
  };

  useEffect(() => {
    if (Object.keys(formErrors).length === 0 && isSubmitting) {
      createLeaves();
    }
  }, [formErrors]);

  const createLeaves = async () => {
    swal({
      title: "Loading",
      text: "Please wait...",
      buttons: false,
      closeOnClickOutside: false,
      closeOnEsc: false,
      width: "10%",
      content: createSwalLoaderNode(),
    });
    try {
      const formattedDate = moment(leaveValues.date, "YYYY-MM-DD").format("DD-MM-YYYY");
      const dataToSend = { ...leaveValues, date: formattedDate };

      let response = await AuthApi.createHoliday(dataToSend);
      swal.close();
      if (response && response.status === true) {
        const selectedYear = getFinancialYearForDate(leaveValues.date);
        swal("Success", "Holiday added successfully", "success").then(() => {
          props.history.push({
            pathname: "/holiday-leaves",
            state: {
              selectedYear,
              date: formattedDate,
            },
          });
        });
      } else {
        const errorMessage = response.message || "An error occurred.";
        swal({
          title: "OOPS",
          text: errorMessage,
          icon: "error",
        });
      }
    } catch (error) {
      swal.close();
      console.error("Error creating leave:", error);
      const errorMessage = error.response?.data?.message || "An error occurred while creating the leave.";
      swal({
        title: "Error",
        text: errorMessage,
        icon: "error",
      });
    }
  };

  return (
    <div>
      <AuthCheckComponent authToken={props.authToken} />
      <Header
        {...props}
        authUser={props.authUser}
        component={
          <div>
            <div className="holiday-breadcrumb-card">
              <Breadcrumb
                {...props}
                primaryPageName="Holidays"
                primaryPageLink="/holiday-leaves"
                isSecondaryPage={true}
                secondaryPageName="Add Holiday"
              />
            </div>
            <div className="holiday-form-card">
              <Typography variant="h2" className="common-form-page-title holiday-form-title">Add Holiday Leave</Typography>
              <form className={`${classes.form} common-form-fields`} onSubmit={handleSubmit}>
                <Grid container className={classes.root} spacing={5}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      id="leaveName"
                      name="leaveName"
                      label="Holiday Name"
                      variant="outlined"
                      error={formErrors.leaveName && true}
                      value={leaveValues.leaveName}
                      onChange={handleChange}
                      className={`holiday-form-input ${formErrors.leaveName ? "input-error" : ""}`}
                      inputProps={{ maxLength: 100 }}
                    />
                    {formErrors.leaveName && (
                      <span className="error">{formErrors.leaveName}</span>
                    )}
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DatePicker
                        label="Date"
                        format="dd-MM-yyyy"
                        value={leaveValues.date ? new Date(leaveValues.date) : null}
                        onChange={handleDateChange}
                        slotProps={{
                          textField: {
                            fullWidth: true,
                            variant: "outlined",
                            error: !!formErrors.date,
                            className: `holiday-form-input holiday-date-picker-input ${formErrors.date ? "input-error" : ""}`,
                            size: "medium",
                          },
                          popper: {
                            className: "holiday-datepicker-popper",
                          },
                          day: {
                            sx: {
                              "&.Mui-selected": {
                                backgroundColor: "#036dda",
                                color: "#fff",
                                "&:hover": { backgroundColor: "#0258b8" },
                              },
                              "&:hover": { backgroundColor: "rgba(3,109,218,0.1)" },
                              borderRadius: "8px",
                            },
                          },
                          calendarHeader: {
                            sx: {
                              color: "#036dda",
                              fontWeight: 700,
                            },
                          },
                        }}
                      />
                    </LocalizationProvider>
                    {formErrors.date && (
                      <span className="error">{formErrors.date}</span>
                    )}
                  </Grid>
                </Grid>
                <div className="holiday-form-actions">
                  <Button
                    type="submit"
                    className="btn-success"
                    style={{ textTransform: 'none' }}
                    variant="contained"
                    color="primary"
                  >
                    Save
                  </Button>
                  <Button
                    type="button"
                    className="btn-cancel"
                    style={{ textTransform: 'none' }}
                    onClick={(e) => {
                      e.preventDefault();
                      props.history.push("/holiday-leaves");
                    }}
                  >
                    Cancel
                  </Button>
                </div>
              </form>
            </div>
          </div>
        }
      />
      <Footer />
    </div>
  );
};

export default AddLeaves;
